export enum ChatFilter {
  ALL = 'all',
  EVENTS = 'event',
  MERCHANTS = 'merchant',
  GROUPS = 'group',
}

export function getChatFilterName(filter: ChatFilter): string {
  switch (filter) {
    case ChatFilter.ALL:
      return 'All';
    case ChatFilter.GROUPS:
      return 'Groups';
    case ChatFilter.EVENTS:
      return 'Events';
    case ChatFilter.MERCHANTS:
      return 'Merchants';
  }
}
